const {tarotSettings} = window;

function shuffle(array) {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]]; // Swap elements
	}

	return array;
}

class TarotSpread {
	constructor(maxSelected) {
		this.maxSelected = parseInt(maxSelected);
		this.selectedCards = [];
		this.isCompleted = false;
		this.wrap = document.querySelector('.tarot-wrap');
		this.container = document.querySelector('.tarot-container');

		this.cards = this.initializeCards();

		this.angleStep = 1.88 * (Math.PI) / this.cards.length;
		this.animationDelay = 1000 / this.cards.length;

		this.onReset = this.reset.bind(this);
		this.onResizeThrottled = Helpers.throttle(this.onResize.bind(this), 50);
		this.onLoadMeanings = this.loadCardMeanings.bind(this);

		this.initialize();
	}

	async initialize() {
		await this.setContainerHeight(this.container.offsetWidth);
		this.shuffleCards();
		await this.arrangeCards();
		this.addEventListeners();
	}

	initializeCards() {
		const cards = [];

		document.querySelectorAll('.tarot-card').forEach(card => {
			const cardInstance = new TarotCard(card);
			cards.push(cardInstance);
			cardInstance.instance.addEventListener('card-selected', () => this.clickCardHandler(cardInstance));
		});

		return cards;
	}

	shuffleCards() {
		shuffle(this.cards);

		this.cards.forEach(card => {
			card.setReversed(Math.random() > 0.5);
		});

		// this.cards.map(card => card.loadImage());
	}

	addEventListeners() {
		document.querySelector('[data-meaning-button]').addEventListener('click', this.onLoadMeanings);
		window.addEventListener('resize', this.onResizeThrottled);
		// document.querySelector('[data-reset]').addEventListener('click', this.onReset);
	}

	removeEventListeners() {
		document.querySelector('[data-meaning-button]').removeEventListener('click', this.onLoadMeanings);
		window.removeEventListener('resize', this.onResizeThrottled);
		// document.querySelector('[data-reset]').removeEventListener('click', this.onReset);
	}

	async onResize() {
		this.wrap.classList.add('is-resizing');

		if (this.isCompleted) {
			const [_, cardHeight] = this.getCardDimensions();
			await this.setContainerHeight(cardHeight, true);
		} else {
			await this.setContainerHeight(this.container.offsetWidth, true);
		}

		this.updateCardPositions();
		this.wrap.classList.remove('is-resizing');
	}

	clickCardHandler(card) {
		if (card.isSelected()) {
			return;
		}

		card.setSelected();
		card.removeEventListeners();

		this.selectedCards.push(card);
		this.displaySelectedCardNames();

		if (this.selectedCards.length === this.maxSelected) {
			this.cards.forEach(card => {
				card.removeEventListeners();
			});

			this.markAsCompleted();
		}
	}

	loadCardMeanings() {
		const { ajaxUrl, spreadType, nonce } = tarotSettings;
		const selected = this.getSelectedCards();
		const button = document.querySelector('[data-meaning-button]');

		button.classList.add('is-working');

		jQuery.ajax({
			url: ajaxUrl,
			type: 'POST',
			data: {
				action: 'get_tarot_meaning',
				nonce: nonce,
				type: spreadType,
				cards: selected.map(card => ({
					id: card.getId(),
					reversed: card.isReversed()
				}))
			},
			success: function(response) {
				button.style.display = 'none';

				if (response.success) {
					const meaningContainer = document.querySelector('.tarot-action-meaning');
					meaningContainer.innerHTML = response.data.html;
				}
			},
			complete: function() {
				button.classList.remove('is-working');
			}
		});
	}

	async arrangeCards() {
		const promises = this.cards.map((card, index) => {
			const angle = index * this.angleStep;
			const { x, y } = this.calculatePosition(angle, this.radius);
			const { x: hoverX, y: hoverY } = this.calculatePosition(angle, this.radius + 20);

			return new Promise(resolve => {
				setTimeout(() => {
					card.updateState({
						x: x,
						y: y,
						hoverX: hoverX,
						hoverY: hoverY,
						angle: angle,
						position: 'deck',
						zIndex: index
					});
					resolve();
				}, this.animationDelay * index);
			});
		});

		await Promise.all(promises);
	}

	updateCardPositions() {
		this.cards.forEach((card, index) => {
			const angle = index * this.angleStep;

			if (card.getPosition() === 'showcase') {
				const { x, y } = this.calculateSelectedPosition(this.selectedCards.indexOf(card));
				card.updateState({x, y});
				return;
			}

			const { x, y } = this.calculatePosition(angle, this.radius);
			const { x: hoverX, y: hoverY } = this.calculatePosition(angle, this.radius + 20);

			card.updateState({x, y, hoverX, hoverY, angle});
		});
	}

	calculatePosition(angle, radius) {
		const [cardWidth, cardHeight] = this.getCardDimensions();
		const x = this.centerX + radius * Math.cos(angle) - cardWidth / 2;
		const y = this.centerY + radius * Math.sin(angle) - cardHeight / 2;

		return { x, y };
	}

	calculateSelectedPosition(index) {
		const [cardWidth, cardHeight] = this.getCardDimensions();
		const count = this.selectedCards.length;

		const centerX = this.container.offsetWidth / 2;
		const centerY = cardHeight / 2;

		const x = centerX - (count * cardWidth + (count - 1) * 20) / 2 + index * (cardWidth + 20);
		const y = centerY - cardHeight / 2;

		return { x, y };
	}

	getCardDimensions() {
		return [
			this.cards[0].instance.offsetWidth,
			this.cards[0].instance.offsetHeight
		];
	}

	displaySelectedCardNames() {
		const selectedCards = this.getSelectedCards();
		const selectedContainer = this.wrap.querySelector('.tarot-action-selected');

		this.wrap.querySelector('.tarot-action-title').classList.add('is-hidden');

		selectedContainer.innerHTML = '';

		selectedCards.forEach(card => {
			let name = card.getName();

			if (card.isReversed()) {
				name += ' (перевернута)';
			}

			selectedContainer.insertAdjacentHTML('beforeend', `<div class="tarot-selected-card">${name}</div>`);
		});
	}

	async setContainerHeight(value, force) {
		this.container.style.height = `${value}px`;

		const updateDimensions = () => {
			const [cardWidth, cardHeight] = this.getCardDimensions();

			this.radius = this.container.offsetWidth / 2 - cardHeight / 2;
			this.centerX = this.container.offsetWidth / 2;
			this.centerY = this.container.offsetHeight / 2;
		};

		return new Promise(resolve => {
			if (force) {
				updateDimensions();
				resolve();
			} else {
				setTimeout(() => {
					updateDimensions();
					resolve();
				}, 300);
			}
		});
	}

	animateUnselected() {
		const promises = this.cards.map((card, index) => {
			if (!card.isSelected()) {
				return new Promise(resolve => {
					setTimeout(() => {
						const angle = index * this.angleStep - Math.PI / 2;
						const { x, y } = this.calculatePosition(angle, 0);

						card.updateState({x, y, hoverX: x, hoverY: y, angle, position: 'initial'});
						resolve();
					}, (this.animationDelay / 2) * index);
				})
			}
		});

		return Promise.all(promises);
	}

	animateSelected() {
		const promises = this.getSelectedCards().map((card, index) => {
			return new Promise(resolve => {
				setTimeout(() => {
					const { x, y } = this.calculateSelectedPosition(index);
					card.updateState({x, y, position: 'showcase'});
					resolve();
				}, this.animationDelay * index);
			});
		});

		return Promise.all(promises);
	}

	async markAsCompleted() {
		this.isCompleted = true;
		this.container.classList.add('is-completed');
		document.querySelector('[data-meaning-button]').removeAttribute('disabled');

		const [_, cardHeight] = this.getCardDimensions();

		await this.animateUnselected();

		await Promise.all([
			this.setContainerHeight(cardHeight),
			this.animateSelected()
		]);
	}

	getSelectedCards() {
		return this.selectedCards;
	}

	reset() {
		this.isCompleted = false;
		this.selectedCards = [];

		this.cards.forEach(card => {
			card.setInitialState();
			card.removeEventListeners();
			card.addEventListeners();
		});

		this.removeEventListeners();

		this.wrap.querySelector('.tarot-action-title').classList.remove('is-hidden');
		this.wrap.querySelector('.tarot-action-selected').innerHTML = '';
		this.container.classList.remove('is-completed');
		document.querySelector('[data-meaning-button]').setAttribute('disabled', 'disabled');
		document.querySelector('[data-meaning-button]').style.display = '';
		document.querySelector('.tarot-action-meaning').innerHTML = '';

		this.initialize();
	}
}

class TarotCard {
	positions = [
		'initial',
		'deck',
		'showcase'
	];

	constructor(instance) {
		this.instance = instance;

		this.setInitialState();

		this.clickHandler = this.clickHandler.bind(this);
		this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
		this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);

		this.addEventListeners();
	}

	setInitialState() {
		this.state = {
			x: 0,
			y: 0,
			hoverX: 0,
			hoverY: 0,
			angle: 0,
			zIndex: 0,
			reversed: false,
			selected: false,
			hover: false,
			position: 'initial'
		};
	}

	updateState(props) {
		this.state = {
			...this.state,
			...props
		};

		this.updateUI();
	}

	getPosition() {
		return this.state.position;
	}

	setPosition(position) {
		this.updateState({
			position: position
		});
	}

	isReversed() {
		return this.state.reversed;
	}

	setReversed(reversed) {
		this.updateState({
			reversed: reversed
		});
	}

	isSelected() {
		return this.state.selected;
	}

	isHovered() {
		return this.state.hover;
	}

	setSelected() {
		this.updateState({
			selected: true
		});

		this.loadImage();
	}

	addEventListeners() {
		this.instance.addEventListener('click', this.clickHandler);
		this.instance.addEventListener('mouseenter', this.mouseEnterHandler);
		this.instance.addEventListener('mouseleave', this.mouseLeaveHandler);
	}

	removeEventListeners() {
		this.instance.removeEventListener('click', this.clickHandler);
		this.instance.removeEventListener('mouseenter', this.mouseEnterHandler);
		this.instance.removeEventListener('mouseleave', this.mouseLeaveHandler);
	}

	clickHandler() {
		if (this.getPosition() !== 'deck') {
			return;
		}

		const event = new Event('card-selected', {
			bubbles: true
		});
		this.instance.dispatchEvent(event);
	}

	mouseEnterHandler() {
		this.updateState({
			hover: true
		});
	}

	mouseLeaveHandler() {
		this.updateState({
			hover: false
		});
	}

	updateUI() {
		console.log('updateUI');
		let {x, y, hoverX, hoverY, angle, zIndex} = this.state;

		this.instance.classList[this.isSelected() ? 'add' : 'remove']('is-selected');
		this.instance.classList[this.isReversed() ? 'add' : 'remove']('is-reversed');
		this.instance.classList[this.isHovered() ? 'add' : 'remove']('is-hovered');

		// set z-index
		this.instance.style.zIndex = zIndex;

		// remove previous position class
		this.positions.forEach(position => {
			this.instance.classList.remove(`position-${position}`);
		});

		// add new position class
		this.instance.classList.add(`position-${this.getPosition()}`);

		console.log(angle)

		// calculate angle in degrees
		angle = angle * (180 / Math.PI) + 90;


		if (this.getPosition() === 'showcase') {
			angle = this.prevAngle >= 180 ? 360 : 0; // set nearest 0 or 360 degrees
		} else if (this.isSelected() || this.isHovered()) {
			x = hoverX;
			y = hoverY;
		}

		let transform  =`translate(${x}px, ${y}px) rotate(${angle}deg)`;

		if (this.getPosition() === 'showcase') {
			transform += ' scale(1.1)';
		}

		this.instance.style.transform = transform;
		this.prevAngle = angle;
	}

	loadImage() {
		const image = this.instance.querySelector('img');
		image.src = image.dataset.src;
	}

	getName() {
		return this.instance.dataset.name;
	}

	getId() {
		return this.instance.dataset.id;
	}
}

const tarotSpread = new TarotSpread(tarotSettings.maxSelected);

window.TarotSpread = TarotSpread;